import React from "react";
import { Colors } from "../../Constants/colors";
import InputWrapper from "../input/inputWrapper";
import DropDownOptions, { DropdownOptions } from "../dropdownOptions";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { FontSize } from "../../Constants/Enums/Size.enums";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FLEX_DIRECTION,
  JUSTIFY_CONTENT,
  SPACING,
} from "../../Constants/Enums/styles.enum";
import crossIcon from "./../../images/Cross.svg";
import { DropdownWrapper } from "./DropdownWrapper";

interface Props {
  wrapperClassName?: string;
  label: string;
  options: Array<DropdownOptions>;
  selectedOption: DropdownOptions | null;
  setSelectedOption: (value: DropdownOptions) => unknown;
  wrapperStlye?: React.CSSProperties;
  canBeEmpty?: boolean;
}

const Dropdown = ({
  label,
  wrapperClassName = "",
  selectedOption,
  options,
  setSelectedOption,
  wrapperStlye = {},
  canBeEmpty = false,
}: Props) => {
  const handleClearSelection = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedOption({ value: null, text: "" });
  };

  return (
    <div style={{ ...wrapperStlye }}>
      <InputWrapper label={label}>
        <DropdownWrapper>
          {({ isDropdownClicked, setDropdownClicked }) => (
            <>
              {selectedOption?.text ? (
                <div
                  style={{
                    display: DISPLAY.FLEX,
                    flexDirection: FLEX_DIRECTION.ROW,
                    justifyContent: JUSTIFY_CONTENT.SPACE_BETWEEN,
                    alignItems: ALIGN_ITEMS.CENTER,
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontFamily: FontFamily.POPPINS_REGULAR,
                      fontSize: FontSize.F14,
                      color: Colors.Black,
                      fontWeight: "500",
                    }}
                  >
                    {selectedOption?.text}
                  </p>
                  {canBeEmpty && (
                    <div
                      style={{
                        padding: SPACING.S4,
                        borderRadius: "4px",
                        display: DISPLAY.FLEX,
                        alignItems: ALIGN_ITEMS.CENTER,
                        justifyContent: JUSTIFY_CONTENT.CENTER,
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onClick={handleClearSelection}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor =
                          Colors.VeryLightGrey;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }}
                    >
                      <img
                        src={crossIcon}
                        style={{ width: "16px", height: "16px" }}
                        alt="clear selection"
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    color: Colors.Grey,
                    fontFamily: FontFamily.POPPINS_REGULAR,
                    fontSize: FontSize.F14,
                  }}
                >
                  Select an option...
                </div>
              )}

              <DropDownOptions
                showDropdown={isDropdownClicked}
                onSelect={(value) => {
                  setSelectedOption(value);
                  setDropdownClicked(false);
                }}
                dropdownOption={options}
                selectedOption={selectedOption as DropdownOptions}
              />
            </>
          )}
        </DropdownWrapper>
      </InputWrapper>
    </div>
  );
};
export default Dropdown;
